import { render, staticRenderFns } from "./BuyFactorComponent.vue?vue&type=template&id=3eafa000&"
import script from "./BuyFactorComponent.vue?vue&type=script&lang=js&"
export * from "./BuyFactorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports